export default {"src":"/_next/static/media/instacart.c9620ac8.svg","height":20,"width":120,"blurWidth":0,"blurHeight":0};